import React, { useEffect, useState } from 'react';
import { BrowserRouter } from 'react-router-dom';

export interface AutoRefreshingRouterProps {}

export const AutoRefreshingRouter: React.FC<AutoRefreshingRouterProps> = ({ children }) => {
  const [shouldRefresh, setShouldRefresh] = useState(false);

  useEffect(() => {
    const id = setTimeout(
      () => setShouldRefresh(true),
      1000 * 60 * 60 * 6 // 6 hours in milliseconds
    );
    return () => clearTimeout(id);
  }, []);

  return (
    <BrowserRouter forceRefresh={shouldRefresh}>
      {children}
    </BrowserRouter>
  );
}
